import React, { useEffect, useState, createElement } from 'react';
import { Calendar, Lock, AlertTriangle, X, MousePointerClick, Download, Mail, MessageCircle } from 'lucide-react';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
export function ThankYouMPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  // Function to get next Tuesday date (for /meta-martes traffic)
  const getNextTuesday = () => {
    const now = new Date();
    // Convert to EST timezone
    const estTime = new Date(now.toLocaleString('en-US', {
      timeZone: 'America/New_York'
    }));
    const currentDay = estTime.getDay(); // 0 = Sunday, 2 = Tuesday
    const currentHour = estTime.getHours();
    let daysUntilTuesday = 0;
    if (currentDay === 2) {
      // It's Tuesday
      if (currentHour >= 19) {
        // After 7pm EST, show next week's Tuesday
        daysUntilTuesday = 7;
      } else {
        // Before 7pm EST, show today
        daysUntilTuesday = 0;
      }
    } else if (currentDay < 2) {
      // Before Tuesday this week (Sunday=0, Monday=1)
      daysUntilTuesday = 2 - currentDay;
    } else {
      // After Tuesday (Wednesday=3, Thursday=4, Friday=5, Saturday=6)
      daysUntilTuesday = 7 - currentDay + 2;
    }
    const nextTuesday = new Date(estTime);
    nextTuesday.setDate(estTime.getDate() + daysUntilTuesday);
    const day = nextTuesday.getDate();
    return day;
  };
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('init', '4285913388317138');
    window.fbq('track', 'PageView');
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/nrxtdp5ht5.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    // Add Wistia player styles
    const style = document.createElement('style');
    style.textContent = `
      wistia-player[media-id='nrxtdp5ht5']:not(:defined) { 
        background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/nrxtdp5ht5/swatch'); 
        display: block; 
        filter: blur(5px); 
        padding-top:56.25%; 
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(playerScript);
      document.head.removeChild(embedScript);
      document.head.removeChild(style);
    };
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans" data-id="element-2470">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-2471">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-2472" />
      </noscript>

      {/* Cyan Header Banner - Tuesday date */}
      <div className="bg-gradient-to-r from-[#00f7fc] to-[#00d7dc] py-3 md:py-5 px-4" data-id="element-2473">
        <div className="max-w-4xl mx-auto text-center" data-id="element-2474">
          <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-2475">
            <Calendar className="w-5 h-5 md:w-7 md:h-7 text-black" data-id="element-2476" />
            <h1 className="text-xs sm:text-sm md:text-lg lg:text-xl font-bold whitespace-nowrap text-black tracking-tight" data-id="element-2477">
              Reservada La Fecha: Martes {getNextTuesday()} | 7PM EST (Hora
              Miami)
            </h1>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <main className="max-w-6xl mx-auto px-4 py-6 md:py-10" data-id="element-2478">
        {/* Main Headline */}
        <div className="text-center mb-6 md:mb-10" data-id="element-2479">
          <div className="mb-3" data-id="element-2480">
            <div className="inline-flex items-center gap-2 bg-[#00f7fc]/20 border border-[#00f7fc]/50 rounded-full px-4 py-2 mb-3" data-id="element-2481">
              <Lock className="w-4 h-4 text-[#00f7fc]" data-id="element-2482" />
              <span className="text-sm md:text-base font-semibold text-[#00f7fc]" data-id="element-2483">
                Tu lugar está confirmado
              </span>
            </div>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-3 leading-tight tracking-tight" data-id="element-2484">
            Completa Estos 3 Pasos Importantes
            <br data-id="element-2485" />
            <span className="text-[#00f7fc]" data-id="element-2486">Antes De Que Te Vayas</span>
          </h2>
          <p className="text-base md:text-lg text-gray-100 max-w-2xl mx-auto" data-id="element-2487">
            Para aprovechar al máximo la masterclass
          </p>
          <div className="w-full h-1 bg-gradient-to-r from-transparent via-white to-transparent mt-5" data-id="element-2488"></div>
        </div>

        {/* Video + WhatsApp CTA Side by Side */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 mb-10 md:mb-14" data-id="element-2489">
          {/* Video Section - Left (3 columns) */}
          <div className="lg:col-span-3" data-id="element-2490">
            <div className="w-full overflow-hidden border border-[#00f7fc]" style={{
            boxShadow: `
                0 0 20px rgba(0, 247, 252, 0.6),
                0 0 40px rgba(0, 247, 252, 0.4),
                0 0 60px rgba(0, 247, 252, 0.3),
                0 0 80px rgba(0, 215, 220, 0.2),
                inset 0 0 20px rgba(0, 247, 252, 0.1)
              `
          }} data-id="element-2491">
              <wistia-player media-id="nrxtdp5ht5" aspect="1.7777777777777777" data-id="element-2492"></wistia-player>
            </div>
          </div>

          {/* WhatsApp CTA - Right (2 columns) - PRIORITY #1 */}
          <div className="lg:col-span-2 flex flex-col" data-id="element-2493">
            <div className="bg-gradient-to-br from-[#25D366]/20 to-[#128C7E]/20 border-2 border-[#25D366] rounded-2xl p-5 md:p-6 flex-1 flex flex-col" data-id="element-2494">
              <div className="bg-[#25D366] rounded-full py-2 px-4 text-center mb-4 inline-block" data-id="element-2495">
                <h3 className="text-base md:text-lg font-bold tracking-tight text-white flex items-center justify-center gap-2" data-id="element-2496">
                  <MessageCircle className="w-5 h-5" data-id="element-2497" />
                  Paso #1: Únete Al Grupo
                </h3>
              </div>

              <p className="text-sm md:text-base text-gray-200 mb-4 text-center" data-id="element-2498">
                <span className="font-bold text-[#25D366]" data-id="element-2499">¡IMPORTANTE!</span>{' '}
                Únete ahora al grupo exclusivo de WhatsApp para recibir
                recordatorios y contenido extra.
              </p>

              <a href="https://chat.whatsapp.com/Bt9Hxv3xQbfA0QX5MaAAAL" target="_blank" rel="noopener noreferrer" className="block flex-1 min-h-0" data-id="element-2500">
                <div className="relative group h-full" data-id="element-2501"></div>
              </a>

              <a href="https://chat.whatsapp.com/GDTWSXIrqht4FJw9sIPKI4" target="_blank" rel="noopener noreferrer" className="mt-4 w-full bg-[#25D366] hover:bg-[#128C7E] text-white font-bold py-3 px-6 rounded-full text-center transition-all duration-300 flex items-center justify-center gap-2 shadow-lg hover:shadow-[#25D366]/30" data-id="element-2502">
                <MessageCircle className="w-5 h-5" data-id="element-2503" />
                UNIRME AL GRUPO DE WHATSAPP
              </a>
            </div>
          </div>
        </div>

        {/* Step 2: Exclusive Gift */}
        <div className="mb-6 md:mb-8 max-w-3xl mx-auto" data-id="element-2504">
          <div className="bg-gray-700 rounded-full py-3 md:py-4 px-6 md:px-8 text-center mb-4 md:mb-5 inline-block w-full" data-id="element-2505">
            <h3 className="text-lg md:text-xl font-bold tracking-tight" data-id="element-2506">
              Paso #2: Regalo Exclusivo
            </h3>
          </div>

          <div className="bg-gradient-to-r from-[#00f7fc]/90 to-[#00d7dc]/90 border border-[#00f7fc]/30 rounded-lg p-3 md:p-4 mb-4" data-id="element-2507">
            <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-2508">
              <Download className="w-4 h-4 md:w-5 md:h-5 text-black" data-id="element-2509" />
              <p className="text-sm md:text-base font-semibold text-black" data-id="element-2510">
                Haz clic en la imagen para descargar la guía
              </p>
            </div>
          </div>

          <div className="mb-5 relative group" data-id="element-2511">
            <a href="https://drive.google.com/file/d/1UwCS-6hTXssQIqMUObPKvMnumSsTNm5u/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="block" data-id="element-2512">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-[#00f7fc]/40 to-[#00d7dc]/40 rounded-lg blur-sm opacity-0 group-hover:opacity-100 transition duration-500" data-id="element-2513"></div>
              <div className="relative" data-id="element-2514">
                <img src="https://cdn.magicpatterns.com/uploads/qGszUSvXKGkMXKzhkKHKP9/heylloyd-image-1769473134106.png" alt="Regalo Gratis - Guía Completa de Implementación" className="w-full max-w-3xl mx-auto rounded-lg border border-[#00f7fc]/50 group-hover:border-[#00f7fc] group-hover:scale-[1.01] transition-all duration-300 cursor-pointer shadow-xl" data-id="element-2515" />
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/10 rounded-lg" data-id="element-2516">
                  <div className="bg-[#00f7fc]/95 backdrop-blur-sm text-black px-5 py-2.5 rounded-full font-semibold text-base shadow-lg" data-id="element-2517">
                    Descargar guía
                  </div>
                </div>
              </div>
            </a>
          </div>

          <p className="text-center text-base md:text-lg leading-normal px-4 text-gray-100" data-id="element-2518">
            Antes del workshop, quiero que descargues esta guía y la leas con
            calma.
            <br data-id="element-2519" />
            <br data-id="element-2520" />
            Esta guía no es un regalo más. No es un PDF para ejecutar. Y no es
            algo para "aplicar" todavía.
            <br data-id="element-2521" />
            <br data-id="element-2522" />
            Su único objetivo es ayudarte a llegar al workshop con el marco
            mental correcto.
            <br data-id="element-2523" />
            <br data-id="element-2524" />
            La mayoría de las personas se equivoca antes de empezar—no porque no
            sepa qué hacer, sino porque empieza por el lugar incorrecto.
            <br data-id="element-2525" />
            <br data-id="element-2526" />
            Esta guía te ayudará a entender el orden correcto para que el
            contenido del workshop tenga sentido desde el primer minuto.
          </p>
        </div>

        {/* Step 3: Check Email */}
        <div className="mb-10 md:mb-14 max-w-3xl mx-auto" data-id="element-2527">
          <div className="bg-gray-800/50 border border-gray-700 rounded-xl p-5 md:p-6" data-id="element-2528">
            <div className="flex items-center gap-3 mb-3" data-id="element-2529">
              <div className="bg-yellow-500/20 p-2.5 rounded-full" data-id="element-2530">
                <Mail className="w-6 h-6 text-yellow-500" data-id="element-2531" />
              </div>
              <h3 className="text-lg md:text-xl font-bold tracking-tight" data-id="element-2532">
                Paso #3: Revisa Tu Email
              </h3>
            </div>
            <p className="text-base text-gray-300" data-id="element-2533">
              Revisa tu bandeja de entrada (y spam) para confirmar tu acceso al
              evento.
            </p>
          </div>
        </div>

        {/* BREAKOUT VIDEOS SECTION */}
        <div className="mb-10 md:mb-14 max-w-5xl mx-auto" data-id="element-2534">
          <div className="text-center mb-8" data-id="element-2535">
            <h2 className="text-2xl md:text-3xl font-black mb-3" data-id="element-2536">
              ¿Tienes Dudas?{' '}
              <span className="text-[#00f7fc]" data-id="element-2537">Las Resolvemos Aquí:</span>
            </h2>
            <p className="text-gray-400 text-base" data-id="element-2538">
              Mira estos videos cortos para resolver las preguntas más comunes.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2539">
            {/* Video 1 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-2540">
              <div className="bg-gray-800 relative" data-id="element-2541">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-2542">
                  <iframe src="https://player.vimeo.com/video/1173156247?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 1" data-id="element-2543"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-2544">
                <p className="font-bold text-sm" data-id="element-2545">
                  ¿Y si HEYLLOYD no funciona para mi nicho o tipo de negocio?
                </p>
              </div>
            </div>

            {/* Video 2 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-2546">
              <div className="bg-gray-800 relative" data-id="element-2547">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-2548">
                  <iframe src="https://player.vimeo.com/video/1173156261?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 2" data-id="element-2549"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-2550">
                <p className="font-bold text-sm" data-id="element-2551">
                  Ya he invertido en otros programas y no me funcionaron. ¿Qué
                  hace a este diferente?
                </p>
              </div>
            </div>

            {/* Video 3 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-2552">
              <div className="bg-gray-800 relative" data-id="element-2553">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-2554">
                  <iframe src="https://player.vimeo.com/video/1173156277?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VIDEO 3" data-id="element-2555"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-2556">
                <p className="font-bold text-sm" data-id="element-2557">
                  No tengo tiempo para implementar otro sistema complejo.
                </p>
              </div>
            </div>

            {/* Video 4 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-2558">
              <div className="bg-gray-800 relative" data-id="element-2559">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-2560">
                  <iframe src="https://player.vimeo.com/video/1173156217?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 4" data-id="element-2561"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-2562">
                <p className="font-bold text-sm" data-id="element-2563">
                  Me preocupa el costo de la inversión. ¿Cuál es el ROI real?
                </p>
              </div>
            </div>

            {/* Video 5 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-2564">
              <div className="bg-gray-800 relative" data-id="element-2565">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-2566">
                  <iframe src="https://player.vimeo.com/video/1173156206?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 5" data-id="element-2567"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-2568">
                <p className="font-bold text-sm" data-id="element-2569">
                  ¿No puedo simplemente hacer lo mismo con ChatGPT y otras
                  herramientas gratuitas?
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer data-id="element-2570" />

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-2571">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-2572">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-2573">
              <X className="w-6 h-6" data-id="element-2574" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-2575">
              Términos y Condiciones
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-2576">
              <p data-id="element-2577">
                Al registrarte y participar en el 48 Hrs AI Cash Machine
                Masterclass, aceptas los siguientes términos y condiciones:
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2578">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-2579">
                Al acceder y utilizar este sitio web y registrarte para el
                evento, aceptas estar sujeto a estos términos y condiciones,
                todas las leyes y regulaciones aplicables.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2580">
                2. Uso del Servicio
              </h3>
              <p data-id="element-2581">
                El contenido proporcionado en el masterclass es solo para fines
                educativos e informativos. No garantizamos resultados
                específicos de ingresos o éxito comercial.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2582">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-2583">
                Todo el contenido, materiales, y recursos proporcionados son
                propiedad de 48 Hrs AI Cash Machine y están protegidos por
                derechos de autor.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2584">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-2585">
                48 Hrs AI Cash Machine no será responsable de ningún daño
                directo, indirecto, incidental o consecuente que resulte del uso
                o la imposibilidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2586">
                5. Modificaciones
              </h3>
              <p data-id="element-2587">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2588">Contacto</h3>
              <p data-id="element-2589">
                Para preguntas sobre estos términos, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc]" data-id="element-2590">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-2591">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-2592">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-2593">
              <X className="w-6 h-6" data-id="element-2594" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-2595">
              Política de Privacidad
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-2596">
              <p data-id="element-2597">
                En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
                privacidad.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2598">
                1. Información que Recopilamos
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-2599">
                <li data-id="element-2600">Nombre y dirección de correo electrónico</li>
                <li data-id="element-2601">Información de registro del evento</li>
                <li data-id="element-2602">Comunicaciones que mantienes con nosotros</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2603">
                2. Uso de la Información
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-2604">
                <li data-id="element-2605">
                  Proporcionar acceso al masterclass y materiales relacionados
                </li>
                <li data-id="element-2606">Enviar comunicaciones sobre el evento</li>
                <li data-id="element-2607">Mejorar nuestros servicios y contenido</li>
                <li data-id="element-2608">Cumplir con obligaciones legales</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2609">
                3. Compartir Información
              </h3>
              <p data-id="element-2610">
                No se compartirá información móvil con terceros ni afiliados con
                fines de marketing ni promocionales.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2611">
                4. Seguridad de Datos
              </h3>
              <p data-id="element-2612">
                Implementamos medidas de seguridad técnicas y organizativas
                apropiadas para proteger tu información personal.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2613">
                5. Tus Derechos
              </h3>
              <p data-id="element-2614">
                Tienes derecho a acceder, corregir o eliminar tu información
                personal. Contáctanos en:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc]" data-id="element-2615">
                  support@truemarketer.com
                </a>
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2616">6. Cookies</h3>
              <p data-id="element-2617">
                Utilizamos cookies y tecnologías similares para mejorar tu
                experiencia en nuestro sitio web.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2618">Contacto</h3>
              <p data-id="element-2619">
                Para preguntas:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc]" data-id="element-2620">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Floating WhatsApp Button */}
      <WhatsAppButton data-id="element-2621" />
    </div>;
}